const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value, key);

export const shouldCompleteFastSimonRequest = payload => {
  const state = classifyFastSimonPayload(payload);
  if (!state.isRecognized || state.hasProducts) return true;
  if (state.hasIsNoResults && payload.isNoResults) return true;
  if (state.hasTotalResults && payload.totalResults === 0) return true;
  return false;
};

export const classifyFastSimonPayload = payload => {
  const value = payload && typeof payload === 'object' ? payload : {};
  const hasProducts = Array.isArray(value.products);
  const hasFacets = Array.isArray(value.facets);
  const hasTotalResults = hasOwn(value, 'totalResults') && Number.isFinite(value.totalResults);
  const hasIsNoResults = typeof value.isNoResults === 'boolean';

  return {
    hasProducts,
    hasFacets,
    hasTotalResults,
    hasIsNoResults,
    isRecognized: hasProducts || hasFacets || hasTotalResults || hasIsNoResults
  };
};

export const isFastSimonErrorPayload = payload => Boolean(payload && typeof payload === 'object' && payload.error === true);

export const resolveNoResultsState = (current, payload) => {
  const state = classifyFastSimonPayload(payload);
  if (state.hasIsNoResults) return payload.isNoResults;
  if (state.hasTotalResults) return payload.totalResults === 0;
  return current;
};

export const resolveTotalResults = (current, payload) => {
  const state = classifyFastSimonPayload(payload);
  return state.hasTotalResults ? payload.totalResults : current;
};

export const createReplaceProductsController = () => {
  let replaceOnNextResponse = false;
  let replaceGenerationId = null;

  return {
    markReplaceOnNextResponse() {
      replaceOnNextResponse = true;
    },
    bindToRequest(requestId) {
      if (replaceOnNextResponse) {
        replaceGenerationId = requestId;
        replaceOnNextResponse = false;
      }
    },
    acceptGeneration(requestId) {
      if (replaceOnNextResponse) {
        replaceGenerationId = requestId;
        replaceOnNextResponse = false;
      }
      return replaceGenerationId === requestId;
    },
    shouldReplace(requestId) {
      return replaceGenerationId === requestId;
    },
    clearAfterProducts(requestId) {
      if (replaceGenerationId === requestId) replaceGenerationId = null;
    },
    get replaceProductsOnNextResponse() {
      return replaceOnNextResponse;
    },
    get replaceGenerationId() {
      return replaceGenerationId;
    }
  };
};
